import type { AccountDetails } from '../store/api-generated';

export default function getPaymentMethod(account: AccountDetails) {
  return account?.financial?.status as 'RECURRING' | 'FIRST' | 'NOT_ENROLLED' | null;
}
